import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
    selector: "cloud",
    templateUrl: "./cloud.component.html",
    styleUrl: "./cloud.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CloudComponent {
  public size = input<number>(50);
  public hideLargeCloud = input<boolean>(false);
}
